class NewsletterModal extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()

    this.handleNewsletterCookie()
  }

  handleNewsletterCookie() {
    const cookieName = 'Cookienewsolivia'
    const userNews = window.BAO.Utils.getCookie(cookieName)

    if (userNews === '') {
      window.BAO.Utils.setCookie(cookieName, 1, 7)
      return
    }

    if (userNews === '1') {
      window.BAO.Utils.setCookie(cookieName, 2, 7)
      return
    }

    if (userNews === '2') {
      window.BAO.Utils.setCookie(cookieName, 4, 7)

      window.setTimeout(() => {
        this.openNewsletterModal()
      }, 3000)
    }
  }

  openNewsletterModal() {
    const drawerManager = window.drawers

    if (!drawerManager) {
      window.setTimeout(() => this.openNewsletterModal(), 50)
      return
    }

    drawerManager.open('newsletter')
  }
}

if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', NewsletterModal)
}
